class CartValidator {
  constructor() {
    this.init();
  }

  init() {
    this.captureCheckoutHrefs(); // Capture initial hrefs
    this.validateCartOnLoad();
    this.observeCartChanges();
    this.observeCartPage(); // Add observer for cart page specifically
  }

  observeCartPage() {
    // Special handling for /cart page where content loads via Ajax
    if (window.location.pathname === '/cart') {
      // Watch for when cart content is injected
      const cartContentObserver = new MutationObserver(() => {
        const cartForm = document.querySelector('.js-ajax-cart-content');
        if (cartForm && cartForm.innerHTML.trim() !== '') {
          this.captureCheckoutHrefs();
          this.restoreCheckoutHrefs();
          
          // Get cart and validate
          if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cart) {
            Shopify.theme.cart.getCart().then((cart) => {
              this.validateCart(cart);
            });
          }
        }
      });

      // Observe the cart content wrapper
      const cartWrapper = document.querySelector('.ajax-cart__form-wrapper');
      if (cartWrapper) {
        cartContentObserver.observe(cartWrapper, {
          childList: true,
          subtree: true
        });
      }

      // Also add a periodic check for cart page to ensure validation persists
      setInterval(() => {
        const checkoutButton = document.querySelector('#checkout-cart');
        if (checkoutButton && !checkoutButton.classList.contains('cart-validation-disabled')) {
          // Button exists but not validated - check cart state
          if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cart) {
            Shopify.theme.cart.getCart().then((cart) => {
              const hasPaid = this.hasAtLeastOnePaidProduct(cart);
              if (!hasPaid) {
                this.validateCart(cart);
              }
            });
          }
        }
      }, 2000); // Check every 2 seconds
    }
  }

  validateCartOnLoad() {
    if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.cart) {
      Shopify.theme.cart.getCart().then((cart) => {
        // Add delay to ensure DOM is fully ready
        setTimeout(() => {
          this.validateCart(cart);
        }, 500);
      });
    }
  }

  observeCartChanges() {
    const originalUpdateView = Shopify.theme.ajaxCart.updateView;
    const originalUpdateCheck = Shopify.theme.ajaxCart.updateCheck;
    const self = this;

    Shopify.theme.ajaxCart.updateView = function(config, Cart) {
      // Capture current checkout hrefs BEFORE cart re-renders
      self.captureCheckoutHrefs();
      
      originalUpdateView.call(this, config, Cart);
      
      setTimeout(() => {
        // Restore hrefs to new DOM elements AFTER cart re-renders
        self.restoreCheckoutHrefs();
        self.validateCart(Cart);
      }, 200); // Increased delay to 200ms for stability
    };

    Shopify.theme.ajaxCart.updateCheck = function(config, Cart) {
      // Capture current checkout hrefs BEFORE cart re-renders
      self.captureCheckoutHrefs();
      
      originalUpdateCheck.call(this, config, Cart);
      
      setTimeout(() => {
        // Restore hrefs to new DOM elements AFTER cart re-renders
        self.restoreCheckoutHrefs();
        self.validateCart(Cart);
      }, 200); // Increased delay to 200ms for stability
    };
  }

  captureCheckoutHrefs() {
    // Store the checkout URLs globally so they survive DOM re-renders
    if (!window._cartValidationCheckoutUrls) {
      window._cartValidationCheckoutUrls = {};
    }

    const checkoutButtons = document.querySelectorAll(
      '#checkout, #checkout-cart, .ajax-cart__button-submit.block__checkout'
    );

    checkoutButtons.forEach(button => {
      const link = button.querySelector('a');
      if (link) {
        const href = link.getAttribute('href');
        // Use button ID if available, otherwise create a unique identifier
        const id = button.id || `checkout-${button.className.replace(/\s+/g, '-')}`;
        
        // Only store if it's a valid checkout URL
        if (href && href !== 'javascript:void(0);' && (href.includes('checkout') || href.includes('/cart/'))) {
          window._cartValidationCheckoutUrls[id] = href;
        }
      }
    });
  }

  restoreCheckoutHrefs() {
    // Restore checkout URLs from global storage to new DOM elements
    if (!window._cartValidationCheckoutUrls) {
      return;
    }

    const checkoutButtons = document.querySelectorAll(
      '#checkout, #checkout-cart, .ajax-cart__button-submit.block__checkout'
    );

    checkoutButtons.forEach(button => {
      const link = button.querySelector('a');
      if (link) {
        // Use button ID if available, otherwise create a unique identifier
        const id = button.id || `checkout-${button.className.replace(/\s+/g, '-')}`;
        const storedHref = window._cartValidationCheckoutUrls[id];
        
        if (storedHref) {
          link.setAttribute('data-original-checkout-href', storedHref);
        } else if (!link.hasAttribute('data-original-checkout-href')) {
          // If no stored href and no attribute, set default
          link.setAttribute('data-original-checkout-href', '/cart/checkout');
        }
      }
    });
  }

  isSampleItem(item) {
    const miniCart = document.getElementById('mini-cart');
    if (!miniCart) return false;

    const giftProductId = miniCart.getAttribute('data-giftproid');
    const wholesaleGiftId = miniCart.getAttribute('wholesale-data-freegift');
    const guestGiftId = miniCart.getAttribute('guest-data-freegift');
    const oldGiftId = miniCart.getAttribute('data-old-giftproid');

    const giftIds = [
      giftProductId,
      wholesaleGiftId,
      guestGiftId,
      oldGiftId
    ].filter(id => id).map(id => parseInt(id));

    const giftSamplesIds = this.getGiftSampleIds();
    
    const itemVariantId = item.variant_id || item.id;
    const itemProductId = item.product_id;

    if (giftIds.includes(itemVariantId) || giftIds.includes(itemProductId)) {
      return true;
    }

    if (giftSamplesIds.includes(itemVariantId) || giftSamplesIds.includes(itemProductId)) {
      return true;
    }

    if (item.price === 0 || item.final_price === 0) {
      return true;
    }

    if (item.properties && (
      item.properties._sample === 'true' || 
      item.properties._promo === 'true' ||
      item.properties.sample === 'true' ||
      item.properties.promo === 'true'
    )) {
      return true;
    }

    if (item.product_type && (
      item.product_type.toLowerCase().includes('sample') ||
      item.product_type.toLowerCase().includes('promo')
    )) {
      return true;
    }

    return false;
  }

  getGiftSampleIds() {
    const sampleIds = [];
    const luxeSamplesBlock = document.querySelector('.block__luxe-Samples');
    
    if (luxeSamplesBlock) {
      const sampleInputs = luxeSamplesBlock.querySelectorAll('[data-variant]');
      sampleInputs.forEach(input => {
        const variantId = parseInt(input.getAttribute('data-variant'));
        if (variantId) {
          sampleIds.push(variantId);
        }
      });
    }

    return sampleIds;
  }

  hasAtLeastOnePaidProduct(cart) {
    if (!cart || !cart.items || cart.items.length === 0) {
      return false;
    }

    return cart.items.some(item => !this.isSampleItem(item));
  }

  validateCart(cart) {
    if (!cart || cart.item_count === 0) {
      this.removeValidationError();
      this.enableCheckoutButtons();
      return;
    }

    const hasPaidProduct = this.hasAtLeastOnePaidProduct(cart);

    if (!hasPaidProduct) {
      this.disableCheckoutButtons();
      this.showValidationError();
    } else {
      this.enableCheckoutButtons();
      this.removeValidationError();
    }
  }

  disableCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll(
      '#checkout, #checkout-cart, .ajax-cart__button-submit.block__checkout, button.ajax-cart__button-submit.block__checkout'
    );

    checkoutButtons.forEach(button => {
      button.setAttribute('data-cart-validation-disabled', 'true');
      button.setAttribute('disabled', 'disabled');
      button.classList.add('cart-validation-disabled');
      button.style.pointerEvents = 'none';
      
      const link = button.querySelector('a');
      if (link) {
        link.setAttribute('data-cart-validation-disabled', 'true');
        
        // Store original href ONLY if not already stored
        const currentHref = link.getAttribute('href');
        if (currentHref && currentHref !== 'javascript:void(0);' && !link.hasAttribute('data-original-checkout-href')) {
          link.setAttribute('data-original-checkout-href', currentHref);
        }
        
        // Set to void to prevent navigation
        link.setAttribute('href', 'javascript:void(0);');
        link.style.pointerEvents = 'none';
        link.style.opacity = '0.5';
        link.style.cursor = 'not-allowed';
      }
    });
  }

  enableCheckoutButtons() {
    const checkoutButtons = document.querySelectorAll(
      '#checkout, #checkout-cart, .ajax-cart__button-submit.block__checkout, button.ajax-cart__button-submit.block__checkout'
    );

    checkoutButtons.forEach(button => {
      button.removeAttribute('data-cart-validation-disabled');
      button.removeAttribute('disabled');
      button.classList.remove('cart-validation-disabled');
      button.style.pointerEvents = '';
      
      const link = button.querySelector('a');
      if (link) {
        link.removeAttribute('data-cart-validation-disabled');
        
        // Restore original href from data attribute OR use default
        const originalHref = link.getAttribute('data-original-checkout-href');
        if (originalHref) {
          link.setAttribute('href', originalHref);
        } else {
          // Fallback to default checkout URL if no stored href
          link.setAttribute('href', '/cart/checkout');
        }
        
        link.style.pointerEvents = '';
        link.style.opacity = '';
        link.style.cursor = '';
      }
    });
  }

  showValidationError() {
    // Always remove existing errors first
    this.removeValidationError();

    const errorHTML = `
      <div class="cart-validation-error">
        <div class="cart-validation-error__message">
          <div class="cart-validation-error__icon">
            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="9" stroke-width="1.5"/>
              <path d="M10 6V11" stroke-width="1.5" stroke-linecap="round"/>
              <circle cx="10" cy="14" r="1"/>
            </svg>
          </div>
          <div class="cart-validation-error__text">
            <strong>Cart Contains Samples Only</strong>
            Please add at least one product to proceed to checkout.
          </div>
        </div>
      </div>
    `;

    // Determine which cart we're on
    const isCartPage = window.location.pathname === '/cart';
    let errorInserted = false;

    if (isCartPage) {
      // Cart page - try multiple possible locations
      // Option 1: Inside ajax-cart__summary-wrapper, before final-details
      const summaryWrapper = document.querySelector('.ajax-cart__summary-wrapper');
      if (summaryWrapper) {
        const finalDetails = summaryWrapper.querySelector('.ajax-cart__final-details');
        if (finalDetails) {
          finalDetails.insertAdjacentHTML('beforebegin', errorHTML);
          errorInserted = true;
        }
      }
      
      // Option 2: Directly before any final-details on cart page
      if (!errorInserted) {
        const anyFinalDetails = document.querySelector('.js-cart-summary .ajax-cart__final-details');
        if (anyFinalDetails) {
          anyFinalDetails.insertAdjacentHTML('beforebegin', errorHTML);
          errorInserted = true;
        }
      }
    } else {
      // Cart drawer - insert before final details in footer
      const cartDrawerFooter = document.querySelector('.recomm-footer');
      if (cartDrawerFooter) {
        const finalDetails = cartDrawerFooter.querySelector('.ajax-cart__final-details');
        if (finalDetails) {
          finalDetails.insertAdjacentHTML('beforebegin', errorHTML);
          errorInserted = true;
        }
      }
    }

    // Fallback: if error wasn't inserted, try any available final-details
    if (!errorInserted) {
      const anyFinalDetails = document.querySelector('.ajax-cart__final-details');
      if (anyFinalDetails) {
        anyFinalDetails.insertAdjacentHTML('beforebegin', errorHTML);
        errorInserted = true;
      } else {
        // Last resort - insert before checkout buttons
        const checkoutButtons = document.querySelector('.ajax-cart__buttons');
        if (checkoutButtons) {
          checkoutButtons.insertAdjacentHTML('beforebegin', errorHTML);
        }
      }
    }
  }

  removeValidationError() {
    const errors = document.querySelectorAll('.cart-validation-error');
    errors.forEach(error => error.remove());
  }
}

document.addEventListener('DOMContentLoaded', function() {
  if (typeof Shopify !== 'undefined' && Shopify.theme && Shopify.theme.ajaxCart) {
    setTimeout(() => {
      window.cartValidator = new CartValidator();
      
      // Block all click events on disabled checkout buttons and their children (capture phase)
      document.addEventListener('click', function(e) {
        // IMPORTANT: Don't block cart item operations (remove, qty buttons)
        const isCartItemControl = e.target.closest('.js-cart-remove, .ajax-cart__item-remove, .custom-js-cart-remove, [data-ajax-qty-increase], [data-ajax-qty-decrease], [data-item-qty]');
        if (isCartItemControl) {
          return;
        }

        // Check if the click target or any parent has the disabled flag
        const target = e.target.closest('[data-cart-validation-disabled="true"]');
        const button = e.target.closest('button.ajax-cart__button-submit.block__checkout');
        const link = e.target.closest('a[href*="/checkout"]');
        
        // Don't block if clicking inside a cart item (even if validation is active)
        const isInsideCartItem = e.target.closest('.ajax-cart__cart-item');
        if (isInsideCartItem && !target && !button) {
          return;
        }
        
        if (target || (button && button.hasAttribute('data-cart-validation-disabled'))) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) {
            e.stopImmediatePropagation();
          }
          return false;
        }
        
        // Extra check for any checkout link clicks
        if (link && link.hasAttribute('data-cart-validation-disabled')) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) {
            e.stopImmediatePropagation();
          }
          return false;
        }
      }, true);
      
      // Block keyboard events on disabled checkout buttons
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          // Don't block keyboard on cart item controls
          const isCartItemControl = document.activeElement?.closest('.js-cart-remove, .ajax-cart__item-remove, .custom-js-cart-remove, [data-ajax-qty-increase], [data-ajax-qty-decrease], [data-item-qty]');
          if (isCartItemControl) {
            return;
          }

          const target = document.activeElement?.closest('[data-cart-validation-disabled="true"]');
          if (target) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) {
              e.stopImmediatePropagation();
            }
            return false;
          }
        }
      }, true);

      // Additional safety: block form submissions from validation-disabled contexts
      document.addEventListener('submit', function(e) {
        const form = e.target;
        
        // Don't block if submit came from qty change (quantity = 0)
        const qtyInput = document.activeElement?.closest('[data-item-qty]');
        if (qtyInput && parseInt(qtyInput.value) === 0) {
          return;
        }

        const disabledCheckout = form.querySelector('[data-cart-validation-disabled="true"]');
        if (disabledCheckout) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) {
            e.stopImmediatePropagation();
          }
          return false;
        }
      }, true);
    }, 500);
  }
});
